<script>
  import County from "../Components/County.svelte";
  import States from "../Components/States.svelte";
  import Alerts from "./Alerts.svelte";

  import { tick } from "svelte";

  import { slide } from "svelte/transition";

  export let form, autoShow, ownerAddressErrors, renewalAddressErrors;

  let updateAddress,
    updateAddressEl,
    updateAddressText = "Update Address";

  if (autoShow) {
    updateAddress = true;
  }

  function clearRenewalAddress() {
    $form.renewalAddr = {
      Address1: null,
      Address2: null,
      City: null,
      State: "",
      ZipCode: null,
      County: null,
    };
  }

  async function toggleAddress(event) {
    updateAddress = !updateAddress;
    updateAddressText = !updateAddress
      ? "Update Address"
      : "Finished with Addresses";

    await tick();

    let i = 1;
    let interval = await setInterval(() => {
      i++;
      updateAddressEl.scrollIntoView({
        behavior: "smooth",
      });
      if (i > 200) {
        clearInterval(interval);
        i = 1;
      }
    }, 2);
  }
</script>

<div>
  {#if !autoShow}
    <button
      class="btn"
      class:btn-outline-primary={!updateAddress}
      class:btn-primary={updateAddress}
      on:click|preventDefault={toggleAddress}
      ><i
        class="bi"
        class:bi-house={!updateAddress}
        class:bi-house-check={updateAddress}
      ></i>
      {updateAddressText}</button
    >
  {/if}
  <div class="row mt-2" bind:this={updateAddressEl}>
    {#if updateAddress}
      <div class="col-12 col-md-6" transition:slide>
        <div class="mb-3">
          <div class="fs-4">Owner Address</div>
          <span class="text-muted small"
            >Address of your primary residence.</span
          >
        </div>
        <Alerts errors={ownerAddressErrors} />
        <div class="row g-3">
          <div class="col-12">
            <div class="form-floating">
              <input
                type="text"
                class="form-control form-control-sm"
                id="inputAddress"
                placeholder="1234 Main St"
                class:is-invalid={$form.errors["ownerAddr.Address1"]}
                bind:value={$form.ownerAddr.Address1}
              />
              <label for="inputAddress" class="form-label">Address 1</label>
              {#if $form.errors["ownerAddr.Address1"]}
                <div class="invalid-feedback">
                  {$form.errors["ownerAddr.Address1"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="inputAddress2"
                placeholder="Apartment, studio, or floor"
                bind:value={$form.ownerAddr.Address2}
              />
              <label for="inputAddress2" class="form-label">Address 2</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="inputCity"
                placeholder="City"
                class:is-invalid={$form.errors["ownerAddr.City"]}
                bind:value={$form.ownerAddr.City}
              />
              <label for="inputCity" class="form-label">City</label>
              {#if $form.errors["ownerAddr.City"]}
                <div class="invalid-feedback">
                  {$form.errors["ownerAddr.City"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <States
                id="inputState"
                bind:value={$form.ownerAddr.State}
                invalid={$form.errors["ownerAddr.State"]}
              />
              {#if $form.errors["ownerAddr.State"]}
                <div class="invalid-feedback">
                  {$form.errors["ownerAddr.State"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input
                type="text"
                class="form-control input-zip"
                id="inputZip"
                placeholder="00000"
                class:is-invalid={$form.errors["ownerAddr.ZipCode"]}
                bind:value={$form.ownerAddr.ZipCode}
              />
              <label for="inputZip" class="form-label">Zip</label>
              {#if $form.errors["ownerAddr.ZipCode"]}
                <div class="invalid-feedback">
                  {$form.errors["ownerAddr.ZipCode"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <County
                id="inputOwnerCounty"
                bind:value={$form.ownerAddr.County}
                state={$form.ownerAddr.State}
                invalid={$form.errors["ownerAddr.County"]}
              />
              {#if $form.errors["ownerAddr.County"]}
                <div class="invalid-feedback">
                  {$form.errors["ownerAddr.County"]}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mt-4 mt-md-0" transition:slide>
        <div class="mb-3">
          <div class="row justify-content-between align-items-center">
            <div class="col">
              <span class="fs-4">Renewal Address</span><br />
              <span class="text-muted small"
                >This is the address where renewal reminders should be mailed.</span
              >
            </div>
            <div class="col-auto">
              <button
                class="btn btn-sm btn-outline-danger"
                type="button"
                on:click={clearRenewalAddress}>Clear</button
              >
            </div>
          </div>
        </div>
        <Alerts errors={renewalAddressErrors} />
        <div class="row g-3">
          <div class="col-12">
            <div class="form-floating">
              <input
                type="text"
                class="form-control form-control-sm"
                id="inputRenewalAddress"
                placeholder="1234 Main St"
                bind:value={$form.renewalAddr.Address1}
                class:is-invalid={$form.errors["renewalAddr.Address1"]}
              />
              <label for="inputRenewalAddress" class="form-label"
                >Address 1</label
              >
              {#if $form.errors["renewalAddr.Address1"]}
                <div class="invalid-feedback">
                  {$form.errors["renewalAddr.Address1"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="inputRenewalAddress2"
                placeholder="Apartment, studio, or floor"
                bind:value={$form.renewalAddr.Address2}
              />
              <label for="inputRenewalAddress2" class="form-label"
                >Address 2</label
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="inputRenewalCity"
                placeholder="City"
                class:is-invalid={$form.errors["renewalAddr.City"]}
                bind:value={$form.renewalAddr.City}
              />
              <label for="inputRenewalCity" class="form-label">City</label>
              {#if $form.errors["renewalAddr.City"]}
                <div class="invalid-feedback">
                  {$form.errors["renewalAddr.City"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating">
              <States
                id="inputRenewalState"
                invalid={$form.errors["renewalAddr.State"]}
                bind:value={$form.renewalAddr.State}
              />
              {#if $form.errors["renewalAddr.State"]}
                <div class="invalid-feedback">
                  {$form.errors["renewalAddr.State"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input
                type="text"
                class="form-control input-zip"
                id="inputRenewalZip"
                placeholder="00000"
                class:is-invalid={$form.errors["renewalAddr.ZipCode"]}
                bind:value={$form.renewalAddr.ZipCode}
              />
              <label for="inputRenewalZip" class="form-label">Zip</label>
              {#if $form.errors["renewalAddr.ZipCode"]}
                <div class="invalid-feedback">
                  {$form.errors["renewalAddr.ZipCode"]}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</div>
